import {
	forEach, uniq
} from "lodash";
import {
	EVENT_FILTER_ALL_OPTIONS,
	FIELD_TYPES,
	IS_NOT_AVAILABLE_OPTIONS,
	IS_NOT_AVAILABLE_VALUE
} from "constants.js";
import {
	TRIGGER_TYPES,
	UI_OPERATOR_TYPES
} from "../screens/rule-provider/constants";
import { getSeasonsByEffectiveRanges } from "../utils/getSeasonsByEffectiveRanges";

function FilterService(ruleService, appState, $logger, featureHelper) {
	const ctrl = this;

	const getFullItemValue = (fieldConfig, currentItem, parentItem, isEntityItem, currentDetailId) => {
		const Classifications = [
			...(parentItem?.Classifications ?? []),
			...(parentItem?.Classification ? [parentItem.Classification] : []),
			...(currentItem?.Classifications ?? []),
			...(currentItem?.Classification ? [currentItem.Classification] : [])
		];

		const Identifiers = (currentItem?.Identifiers || []).concat(parentItem?.Identifiers || []);
		const allCodes = uniq([currentItem.Code, parentItem?.Code]).filter(c => c !== undefined);
		const externalKeys = uniq([currentItem.ExternalKey, parentItem?.ExternalKey]).filter(c => c !== undefined);

		const itemValue = {
			...currentItem,
			FieldId: fieldConfig.Id,
			_code: currentItem.Code,
			Classifications,
			Identifiers,
			DetailId: currentDetailId,
			allCodes,
			externalKeys,
			fieldTemplate: fieldConfig.Template
		};

		if(isEntityItem) {
			if(currentItem.Effective) {
				itemValue.Seasons = getSeasonsByEffectiveRanges(currentItem.Effective, appState.forms.selected.Seasons);
			}
			else {
				itemValue.Seasons = appState.forms.selected.Seasons;
			}
			itemValue.EntityId = currentItem.Id;
		}
		else {
			itemValue.DataId = currentItem.Id;
		}

		return itemValue;
	};

	const evaluateValueCombination = (rule, currentItem, reportValues, evaluationContext) => {
		let triggerRemovedValues = reportValues;

		if(currentItem.fieldTemplate !== "Tags") {
			triggerRemovedValues = triggerRemovedValues.filter(v => v.FieldId !== currentItem.FieldId);
		}

		const triggerAddedValues = [
			...triggerRemovedValues,
			currentItem
		];

		const { detailValuesById } = ruleService.groupValuesByDetailId(triggerAddedValues);
		const headerOnlyValues = triggerAddedValues.filter(v => v.DetailId === undefined);
		detailValuesById[undefined] = headerOnlyValues;

		const ruleEval = ruleService.processSingleRule(rule, triggerAddedValues, detailValuesById, undefined, evaluationContext)
			.then(evaluated => {
				const result = {
					evaluated,
					dataItem: currentItem
				};

				return result;
			});

		return ruleEval;
	};

	ctrl.executeFilterTriggers = (rules, currentValues, currentDetailId, conditionFieldId, repeatId, evaluationContext) => {
		forEach(rules, r => {
			const ruleFilterTriggers = getOrderedRuleFilterTriggers(r);
			const allDataItemFilters = [];
			const allFilterFieldIds = [];

			ruleFilterTriggers.forEach(t => {
				const isEntityTriggerField = t.Field.Type.Code === FIELD_TYPES.entity
					|| t.Field.Type.Code === FIELD_TYPES.entityContact
					|| t.Field.Type?.IsEntity === true
					|| !!t.Field.EntityQueryConfiguration;
				const paramValues = [
					...currentValues
				];

				allFilterFieldIds.push(t.Field.Id);
				forEach(t.Field.Data, d => {
					if(d.Entities) {
						d.Entities.forEach(e => {
							const entityItem = getFullItemValue(t.Field, e.Entity, d, isEntityTriggerField, currentDetailId);
							const ruleEval = evaluateValueCombination(r, entityItem, paramValues, evaluationContext)
								.then(result => ({ result, fieldId: t.Field.Id }));
							allDataItemFilters.push(ruleEval);
						});
					}
					else {
						const item = getFullItemValue(t.Field, d, undefined, isEntityTriggerField, currentDetailId);
						const ruleEval = evaluateValueCombination(r, item, paramValues, evaluationContext)
							.then(result => ({ result, fieldId: t.Field.Id }));
						allDataItemFilters.push(ruleEval);
					}
				});

				const shouldAddNaOption = featureHelper.checkNotAvailable(t.Field, IS_NOT_AVAILABLE_OPTIONS.supported);
				if(shouldAddNaOption) {
					const notAvailableDataItem = {
						FieldId: t.Field.Id,
						_code: IS_NOT_AVAILABLE_VALUE,
						Id: IS_NOT_AVAILABLE_VALUE,
						[isEntityTriggerField ? "EntityId" : "DataId"]: IS_NOT_AVAILABLE_VALUE,
						IsNotAvailable: true,
						Name: "not available",
						DetailId: currentDetailId
					};
					const ruleEval = evaluateValueCombination(r, notAvailableDataItem, paramValues, evaluationContext)
						.then(result => ({ result, fieldId: t.Field.Id }));
					allDataItemFilters.push(ruleEval);
				}
			});

			Promise.all(allDataItemFilters)
				.then(evals => {
					const trueEvaluations = Object.values(evals)
						.reduce((acc, e) => {
							if(acc[e.fieldId] === undefined) {
								acc[e.fieldId] = {
									fieldId: e.fieldId,
									dataItemIds: []
								};
							}
							if(e.result.evaluated) {
								acc[e.fieldId].dataItemIds.push(e.result.dataItem.Id);
							}
							return acc;
						}, {});

					Object.values(trueEvaluations).forEach(e => {
						evaluationContext.reportScope.events.trigger(EVENT_FILTER_ALL_OPTIONS(e.fieldId, repeatId), { ids: e.dataItemIds });
					});
				});
		});
	};

	function getOrderedRuleFilterTriggers(rule) {
		if(rule.Triggers && rule.Triggers.length > 0) {
			const filterTriggers = rule.Triggers.filter(t =>
				t.Type?.Code === TRIGGER_TYPES.userInterface
					&& t.Operator?.Code === UI_OPERATOR_TYPES.filter
			);

			const orderedTriggers = [...filterTriggers].sort((a, b) => a.order < b.order ? -1 : 1);

			return orderedTriggers;
		}
		return [];
	}
}

export default angular
	.module("vesl.services.filter-service", [])
	.service("filterService", FilterService).name;
